import { render } from "./GenerateProduct.vue?vue&type=template&id=03f1876a&scoped=true"
import script from "./GenerateProduct.vue?vue&type=script&lang=js"
export * from "./GenerateProduct.vue?vue&type=script&lang=js"

import "./GenerateProduct.vue?vue&type=style&index=0&id=03f1876a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f1876a"]])

export default __exports__